module.exports = __webpack_public_path__ + "img/65.7ca67ff1.webp";